import clsx from 'clsx';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { formatDateSafe } from '@/utils/dateUtils';
import { resolveSegmentDecisionSource, resolveSegmentReviewState, sortSegmentsByDate } from '../../../utils/vacationSegments';
import { SEGMENT_REVIEW_BADGES } from '../vacationApprovalCard.definitions';
import type { ApprovalSegmentListProps } from '../vacationApprovalCard.types';

export function ApprovalSegmentList({ segments, dpSegmentDecisions, clientSegmentDecisions, requestStatus }: ApprovalSegmentListProps) {
    return (
        <ul className="space-y-2">
            {sortSegmentsByDate(segments).map((segment) => {
                const resolved = resolveSegmentDecisionSource({ dpSegmentDecisions, clientSegmentDecisions }, segment.order);
                const state = resolveSegmentReviewState(resolved?.decision, requestStatus);
                const badge = SEGMENT_REVIEW_BADGES[resolved?.source ?? 'dp'][state];

                return (
                    <li
                        key={segment.order}
                        className="flex flex-wrap items-center gap-2 rounded-xl bg-raro-surface-50 px-3 py-2"
                    >
                        <CalendarDaysIcon className="h-4 w-4 shrink-0 text-primary-500" aria-hidden="true" />
                        <span className="text-sm font-medium text-raro-gray-800 font-montserrat">
                            {formatDateSafe(segment.startDate)} a {formatDateSafe(segment.endDate)}
                        </span>
                        {badge && (
                            <span
                                className={clsx(
                                    'rounded-full px-2 py-0.5 text-[11px] font-semibold font-montserrat',
                                    badge.className
                                )}
                            >
                                {badge.label}
                            </span>
                        )}
                        <span className="ml-auto shrink-0 text-xs font-semibold text-primary-700 font-montserrat">
                            {segment.days} dias
                        </span>
                    </li>
                );
            })}
        </ul>
    );
}

export default ApprovalSegmentList;
